module.exports = __webpack_public_path__ + "img/loginBG.950d2638.jpg";